import Vue from 'vue';
import Component from 'vue-class-component';
import EdInstitutionCalendar from '@/tools/components/ed-institution-calendar/ed-institution-calendar.component.vue';

@Component({
  name: 'school-calendar-admin',
  components: {
    EdInstitutionCalendar,
  }
})
export default class SchoolCalendarAdmin extends Vue {


}
